import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { customerApi } from "../lib/customerApi";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await customerApi.post("/customer/forgot-password", { email });
      setDone(true);
    } catch {
      toast.error("Could not send reset link. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16" data-testid="forgot-password-page">
      <div className="w-full max-w-md text-center">
        <p className="eyebrow">Reset password</p>
        <h1 className="font-serif-display text-5xl mt-3">Forgotten?</h1>
        {done ? (
          <p className="mt-8 text-[#4A4A4A] text-sm leading-relaxed">
            If <span className="text-[#1A1A1A]">{email}</span> is registered with us, a reset link is on its way. The link is valid for one hour.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5 text-left">
            <label className="block">
              <span className="eyebrow block mb-2">Email</span>
              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-[#a89e80] bg-transparent px-4 py-3 outline-none focus:border-[#1A1A1A]"
                data-testid="forgot-email"
              />
            </label>
            <button
              disabled={loading}
              className="w-full bg-[#1A1A1A] text-[#c3ba9e] py-4 text-[11px] tracking-[0.28em] uppercase disabled:opacity-60"
              data-testid="forgot-submit"
            >
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <p className="mt-8 text-sm text-[#4A4A4A]">
          <Link to="/login" className="text-[#1A1A1A] underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
